import _defineProperty from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Component } from 'inferno';
var contextId = 0;
export var createContext = function createContext(defaultValue) {
  var id = contextId++;
  return {
    id: id,
    defaultValue: defaultValue,
    Provider:
    /*#__PURE__*/
    function (_Component) {
      _inherits(Provider, _Component);

      function Provider() {
        _classCallCheck(this, Provider);

        return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
      }

      _createClass(Provider, [{
        key: "getChildContext",
        value: function getChildContext() {
          return Object.assign(Object.assign({}, this.context), _defineProperty({}, id, this.props.value || defaultValue));
        }
      }, {
        key: "render",
        value: function render() {
          return this.props.children;
        }
      }]);

      return Provider;
    }(Component)
  };
};